// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueRouter from 'vue-router'
import errorMessage from './assets/js/error_parameters'
import utils from './assets/js/utils'
import ElementUI from 'element-ui'
import $ from 'jquery'
import Vuex from 'vuex'

import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)

require('./assets/css/main.css')

Vue.use(VueRouter)
Vue.use(Vuex)

var router = new VueRouter({
  routes: [
    {
      path: '/register',
      name: 'register',
      component (resolve) {
        require.ensure(['./view/account/register.vue'], () => {
          resolve(require('./view/account/register.vue'))
        })
      }
    },
    {
      path: '/forgot_password',
      name: 'forgotPassword',
      component (resolve) {
        require.ensure(['./view/account/forgot_password.vue'], () => {
          resolve(require('./view/account/forgot_password.vue'))
        })
      }
    },
    {
      path: '/card',
      component (resolve) {
        require.ensure(['./view/home/home_root.vue'], () => {
          resolve(require('./view/home/home_root.vue'))
        })
      },
      children: [
        {
          path: '',
          name: 'card',
          component (resolve) {
            require.ensure(['./view/home/card.vue'], () => {
              resolve(require('./view/home/card.vue'))
            })
          }
        },
        {
          path: 'detail/:id',
          name: 'cardDetail',
          component (resolve) {
            require.ensure(['./view/home/card_detail.vue'], () => {
              resolve(require('./view/home/card_detail.vue'))
            })
          }
        }
      ]
    },
    {
      path: '/home',
      name: 'home',
      component (resolve) {
        require.ensure(['./view/home/home.vue'], () => {
          resolve(require('./view/home/home.vue'))
        })
      }
    },
    {
      path: '/user/:id',
      name: 'user',
      component (resolve) {
        require.ensure(['./view/home/user.vue'], () => {
          resolve(require('./view/home/user.vue'))
        })
      }
    },
    {
      path: '/game',
      component (resolve) {
        require.ensure(['./view/home/home_root.vue'], () => {
          resolve(require('./view/home/home_root.vue'))
        })
      },
      children: [
        {
          path: '',
          name: 'game',
          component (resolve) {
            require.ensure(['./view/home/game.vue'], () => {
              resolve(require('./view/home/game.vue'))
            })
          }
        },
        {
          path: 'detail/:id',
          name: 'gameDetail',
          component (resolve) {
            require.ensure(['./view/home/game_detail.vue'], () => {
              resolve(require('./view/home/game_detail.vue'))
            })
          }
        }
      ]
    },
    {
      path: '/pay',
      component (resolve) {
        require.ensure(['./view/home/home_root.vue'], () => {
          resolve(require('./view/home/home_root.vue'))
        })
      },
      children: [
        {
          path: '',
          name: 'pay',
          component (resolve) {
            require.ensure(['./view/home/pay.vue'], () => {
              resolve(require('./view/home/pay.vue'))
            })
          }
        }
      ]
    },
    {
      path: '/custom_service',
      name: 'customService',
      component (resolve) {
        require.ensure(['./view/home/custom_service.vue'], () => {
          resolve(require('./view/home/custom_service.vue'))
        })
      }
    },
    {
      path: '/loginOut',
      name: 'loginOut',
      component (resolve) {
        require.ensure(['./view/home/loginOut.vue'], () => {
          resolve(require('./view/home/loginOut.vue'))
        })
      }
    },
    {
      path: '/paySuccess',
      name: 'paySuccess',
      component (resolve) {
        require.ensure(['./view/home/paySuccess.vue'], () => {
          resolve(require('./view/home/paySuccess.vue'))
        })
      }
    },
    {
      path: '/loginSuccess',
      name: 'loginSuccess',
      component (resolve) {
        require.ensure(['./view/home/loginSuccess.vue'], () => {
          resolve(require('./view/home/loginSuccess.vue'))
        })
      }
    },
    {
      path: '/noGame',
      name: 'noGame',
      component (resolve) {
        require.ensure(['./view/home/noGame.vue'], () => {
          resolve(require('./view/home/noGame.vue'))
        })
      }
    },
    {
      path: '/article/:id',
      name: 'article',
      component (resolve) {
        require.ensure(['./view/home/home_root.vue'], () => {
          resolve(require('./view/home/article.vue'))
        })
      }
    },
    {
      path: '/jianhu',
      name: 'jianhu',
      component (resolve) {
        require.ensure(['./view/home/home_root.vue'], () => {
          resolve(require('./view/home/jianhu.vue'))
        })
      },
      meta: { showNav: false }
    },
    {
      path: '*',
      name: '',
      component (resolve) {
        require.ensure(['./view/home/home.vue'], () => {
          resolve(require('./view/home/home.vue'))
        })
      }
    }
  ]
})

const store = new Vuex.Store({
  state: {
    account: ''
  },
  mutations: {
    updateUserInfo (state, account) {
      state.account = account
    }
  },
  actions: {
    updateUserInfo (context) {
      context.commit('updateUserInfo')
    }
  }
})

Vue.prototype.$errorMessage = errorMessage
Vue.prototype.$utils = utils

Vue.config.productionTip = false

/* eslint-disable no-new */
window.ROOT_APP = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js